<script lang="ts">
import { onMount } from "svelte";

	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.prefectures
</script>

<div class="{klass}">
	<FormWithLabel
		label="都道府県"
		input={service.handlePrefectures}
		values={$model.prefectures}
		value={$model.prefectures[0]}
		inputType="select"
		options={$models}
	/>
</div>